export default "__VITE_ASSET__B89KR3kE__"